/** 遊客／玩家在地面上的位置，供居民每幀讀取，不進 React。 */
export const playerPose = { x: 0, z: 20 }
